import React, { useContext, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import StoreContext from '../../../react-core-lib/components/app/store-context';
import { ReactComponent as CetraLogo } from '../../../assets/icons/CetraLogo.svg';
import { ReactComponent as LogoCircle } from '../../../assets/icons/LogoCircle.svg';
import { registerStyles } from './styles/onboard-register.styles';
import ApiButton from '../../UIControls/api-button/api-button';
import UserApi from '../../../rest-api/user-api';
import VerificationCodeInput from './verification-code-input';
import ResendVerificationLink from './resend-verification-link';
import mixpanel from 'mixpanel-browser';
import KlaviyoApi from '../../../rest-api/klaviyo-api';

const OnboardVerificationCodeScreen = () => {
    const location = useLocation();

    const [userData] = useState(() => {
        const storedUserData = JSON.parse(localStorage.getItem('userData') || '{}');
        return { ...storedUserData, ...location.state?.userData };
    });
    const appStateStore = useContext(StoreContext);
    const { authStore } = useContext(StoreContext);
    const [otp, setOtp] = useState('');
    const [otpComplete, setOtpComplete] = React.useState(false);

    const searchParams = new URLSearchParams(location.search);
    const inviteId = searchParams.get('inviteId');
    const senderId = searchParams.get('senderId');

    const isShowOffer = searchParams.get('LVS');
    console.log('/code local storage ', JSON.parse(localStorage.getItem('userData')));
    console.log('isShowOffer? ', isShowOffer);
    console.log('/code location state', location.state?.userData);

    const verifyCode = async (otp) => {
        const codeAsString = String(otp);
        // console.log(
        //     `verifyCode called email: ${userData.emailAddress}, otp as string: ${codeAsString}`,
        //     userData,
        //     inviteId,
        // );
        const result = await authStore.confirmRegistration(
            userData.emailAddress,
            userData.password,
            codeAsString,
            onRegistrationConfirmed,
        );

        if (result.success) {
        } else {
            console.error('Error during authentication:', result.message);
            throw new Error(result.message);
        }
    };

    // callback function referenced as asyncAppInitializer in auth store
    const onRegistrationConfirmed = async (userId, idToken) => {
        console.warn(`onRegistrationConfirmed called: userId: ${userId}, idToken: ${idToken}`);
        let payload = userData;
        payload.clinicImageId = '';
        payload.showLogoInHandouts = true;
        payload.handouts = [];
        delete payload.password;

        await appStateStore.initializeUserStores(userId);

        // Check the 'LVS' parameter in the query string and store it if true
        if (isShowOffer) {
            localStorage.setItem('LVS', 'true');
        }

        console.log('onRegistrationConfirmed payload to send:', payload);

        try {
            if (inviteId) {
                userData.inviteId = inviteId;
                userData.action = 'acceptInvitation';
                await UserApi.updateClinicianDataMultiuser(idToken, userData);
                var inviteUserData = await UserApi.getClinicianData(idToken);
            } else {
                // Save registration payload so the plan screen can create the clinician record
                // after the user selects a plan. No Stripe subscription is created before selection.
                localStorage.setItem('registrationPayload', JSON.stringify(payload));
            }

            if (appStateStore) {
                console.warn('attempting to store: ', payload, appStateStore, inviteUserData);
                const { userDataStore } = appStateStore;
                if (inviteUserData) {
                    let inviteUserIntegrations = null;
                    if (inviteUserData.multiuserData?.multiuserUsers) {
                        const foundUser = inviteUserData.multiuserData.multiuserUsers.find(
                            (user) => user.userId === userId,
                        );
                        inviteUserIntegrations = foundUser?.integrations || null;
                    }
                    let formattedData = {
                        firstName: inviteUserData.userData.firstName,
                        lastName: inviteUserData.userData.lastName,
                        emailAddress: inviteUserData.userData.emailAddress,
                        mobile: inviteUserData.userData.mobile || '',
                        clinicName: inviteUserData.clinicData.clinicName,
                        clinicNumber: inviteUserData.clinicData.clinicNumber || '',
                        clinicSize: inviteUserData.clinicData.clinicSize || '',
                        clinicImageId: '',
                        showLogoInHandouts: inviteUserData.showLogoInHandouts,
                        handouts: JSON.stringify(inviteUserData.handouts),
                        recentSearches: inviteUserData.recentSearches || [],
                        subscriptionData: {
                            ...inviteUserData.subscriptionData,
                            accountType: 'Clinic-multiuser',
                        },
                        inviteId: inviteId,
                        integrations: inviteUserIntegrations,
                    };
                    userDataStore.setUserData(formattedData);
                } else {
                    // Set only personal data — subscriptionData stays at store defaults (accountType: '')
                    // so hasActiveSubscription() returns false → PENDING_SUBSCRIPTION → plan screen
                    const { subscriptionData: _sd, ...personalData } = payload;
                    personalData.handouts = '[]';
                    userDataStore.setUserData(personalData);
                }
            } else {
                console.error('userDataStore is not defined.');
            }

            await mixpanel.identify(userData.emailAddress);

            // Capture UTM parameters from localStorage (stored on initial page load)
            const storedUtmParams = localStorage.getItem('utmParams');
            const utmParams = storedUtmParams ? JSON.parse(storedUtmParams) : {};

            const mixpanelTrackData = {
                userId: userId,
                email: userData.emailAddress,
                ...(userData.clinicNumber && { clinicNumber: userData.clinicNumber }),
                ...(userData.clinicName && { clinicName: userData.clinicName }),
                ...(userData.mobile && { mobile: userData.mobile }),
                ...(userData.clinicSize && { clinicSize: userData.clinicSize }),
                userName: userData.firstName + ' ' + userData.lastName,
                // UTM tracking
                ...(utmParams.utm_source && { utmSource: utmParams.utm_source }),
                ...(utmParams.utm_medium && { utmMedium: utmParams.utm_medium }),
                ...(utmParams.utm_campaign && { utmCampaign: utmParams.utm_campaign }),
                ...(utmParams.utm_term && { utmTerm: utmParams.utm_term }),
                ...(utmParams.utm_content && { utmContent: utmParams.utm_content }),
            };

            await mixpanel.track('New User Sign Up', mixpanelTrackData);

            const mixpanelPeopleData = {
                $first_name: userData.firstName,
                $last_name: userData.lastName,
                $email: userData.emailAddress,
                ...(userData.mobile && { Mobile: userData.mobile }),
                ...(userData.clinicName && { 'Clinic Name': userData.clinicName }),
                ...(userData.clinicNumber && { 'Clinic Number': userData.clinicNumber }),
                ...(userData.clinicSize && { 'Clinic Size': userData.clinicSize }),
                // UTM tracking on profile
                ...(utmParams.utm_source && { 'Initial UTM Source': utmParams.utm_source }),
                ...(utmParams.utm_medium && { 'Initial UTM Medium': utmParams.utm_medium }),
                ...(utmParams.utm_campaign && { 'Initial UTM Campaign': utmParams.utm_campaign }),
            };

            await mixpanel.people.set(mixpanelPeopleData);

            // Clear UTM params after signup
            localStorage.removeItem('utmParams');

            // Track user description selections as tags
            if (userData.userDescription && userData.userDescription.length > 0) {
                const userDescriptionTagMap = {
                    'Practice Manager / Owner': 'Practice Manager - Owner',
                    Lecturer: 'Lecturer',
                    Receptionist: 'Receptionist',
                    Student: 'Student',
                    Other: 'Other',
                };

                const tags = userData.userDescription.map((desc) => userDescriptionTagMap[desc] || desc);

                // Set people properties with individual boolean flags for segmentation
                const peopleProperties = {
                    'User Description': tags, // Keep array for reference
                    'User Description Text': tags.join(', '), // Readable string
                };

                // Add individual boolean properties for each tag for easy filtering
                tags.forEach((tag) => {
                    peopleProperties[tag] = true;
                });

                await mixpanel.people.set(peopleProperties);

                // Track event with individual boolean properties for segmentation
                const eventProperties = {
                    userId: userId,
                    email: userData.emailAddress,
                    descriptions: tags,
                    descriptionsText: tags.join(', '),
                };

                // Add individual boolean properties to event for filtering
                tags.forEach((tag) => {
                    eventProperties[tag] = true;
                });

                await mixpanel.track('User Description Selected', eventProperties);
            }

            await KlaviyoApi.updateUserInKlaviyo(idToken, payload.emailAddress, 'General');

            localStorage.removeItem('userData');
        } catch (error) {
            console.error('Error during post-registration onboard/code onRegistrationConfirmed:', error);
        }
    };

    return (
        <Box sx={registerStyles.pageContainer}>
            {/* Logo */}
            <Box sx={registerStyles.logo}>
                <Box sx={{ position: 'relative', ...registerStyles.logoSize }}>
                    <Box component={LogoCircle} sx={registerStyles.logoCircle} />
                    <Box component={CetraLogo} sx={registerStyles.logoIcon} />
                </Box>
            </Box>

            {/* OTP Card */}
            <Box sx={{ ...registerStyles.card, border: '1px solid rgba(102, 102, 102, 0.15)' }}>
                <Typography sx={registerStyles.title}>OTP Verification</Typography>
                <Typography sx={{ ...registerStyles.subtitle, mb: 3 }}>
                    We have sent a OTP to the email address provided
                </Typography>

                {/* Input fields */}
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <VerificationCodeInput setOtpComplete={setOtpComplete} onOtpChange={(value) => setOtp(value)} />
                </Box>

                {/* Resend link */}
                <ResendVerificationLink
                    authStore={authStore}
                    emailAddress={userData.emailAddress}
                    sx={{
                        justifyContent: 'center',
                        mt: { xs: '10px', md: '19px' },
                        fontSize: '16px',
                        letterSpacing: '-0.32px',
                        color: 'rgba(97,96,99,0.8)',
                        '& span + span': {
                            color: '#ff669b !important',
                            fontWeight: '400 !important',
                            textDecoration: 'underline',
                        },
                    }}
                />

                {/* Verify button — wrapped in Box to avoid ApiButton sx double-applying mt */}
                <Box sx={{ mt: { xs: '12px', md: '25px' }, width: '100%' }}>
                    <ApiButton
                        apiCall={() => verifyCode(otp)}
                        buttonLabel="Verify"
                        color="primary"
                        errorTitle="Signup error"
                        errorMessage="There was a problem with the signup. Please try again."
                        successTitle="Save Successful"
                        successMessage="Your changes were saved successfully."
                        disabled={!otpComplete}
                        fullWidth={true}
                        buttonVariant="pink"
                        sx={{ width: '100%' }}
                        buttonStyle={{
                            backgroundImage: 'none',
                            backgroundColor: '#ff669b',
                            height: { xs: 48, md: 64 },
                            width: '100%',
                            borderRadius: { xs: '24px', md: '32px' },
                            fontSize: { xs: '16px', md: '22px' },
                            fontWeight: 500,
                            letterSpacing: '-0.44px',
                            color: 'white',
                            textTransform: 'none',
                            '&:hover': {
                                backgroundColor: '#e65588',
                                backgroundImage: 'none',
                            },
                            '&.Mui-disabled': {
                                backgroundImage: 'none !important',
                                backgroundColor: 'rgba(255, 102, 155, 0.5) !important',
                                color: 'rgba(255, 255, 255, 0.7) !important',
                            },
                        }}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default OnboardVerificationCodeScreen;
